import { Check, AlertCircle, Loader2 } from "lucide-react";

/**
 * Phase 4 · Shows the outcome chip under a proposed-action card after
 * execution completes.
 *
 * Props:
 *   state: "succeeded" | "failed" | "cancelled" | "executing"
 *   message?: string (shown on fail/cancel)
 */
export default function ActionResultChip({ state, message }) {
  const base =
    "inline-flex items-center gap-1 text-[11px] font-medium px-2 py-1 rounded-md border";
  if (state === "succeeded") {
    return (
      <span
        data-testid="ai-action-result-succeeded"
        className={`${base} text-emerald-700 border-emerald-200 bg-emerald-50`}
      >
        <Check size={12} /> Done
      </span>
    );
  }
  if (state === "failed") {
    return (
      <span
        data-testid="ai-action-result-failed"
        className={`${base} text-red-700 border-red-200 bg-red-50`}
        title={message}
      >
        <AlertCircle size={12} /> Failed
      </span>
    );
  }
  if (state === "expired") {
    return (
      <span data-testid="ai-action-result-expired"
        className={`${base} text-amber-800 border-amber-200 bg-amber-50`} title={message}>
        <AlertCircle size={12} /> Request a new proposal
      </span>
    );
  }
  if (state === "unknown") {
    return (
      <span data-testid="ai-action-result-unknown"
        className={`${base} text-amber-800 border-amber-200 bg-amber-50`} title={message}>
        <AlertCircle size={12} /> Outcome uncertain — check before retrying
      </span>
    );
  }
  if (state === "cancelled") {
    return (
      <span
        data-testid="ai-action-result-cancelled"
        className={`${base} text-neutral-600 border-neutral-200 bg-neutral-50`}
      >
        Cancelled
      </span>
    );
  }
  return (
    <span
      data-testid="ai-action-result-executing"
      className={`${base} text-[#202B60] border-[#202B60]/20 bg-[#202B60]/5`}
    >
      <Loader2 size={12} className="animate-spin" /> Running…
    </span>
  );
}
